// extracted by mini-css-extract-plugin
export default {"name":"style_name__hRJRc","year":"style_year__7sk5c"};